import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=bd1b864e&"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports